export default "__VITE_ASSET__202f5a33__"